import getConfig from 'next/config';
import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { useApolloClient } from '@apollo/client';
import { useTheme } from '@mui/material/styles';
import styles from './style';
import { getCookie } from '../../hooks/useCookie';
import {
  fetchSimTypes,
  mapApiToInternalSimType,
  mapInternalToApiSimType,
} from './simtypeSelector.util';

const { publicRuntimeConfig } = getConfig();

const ESIMOnlyHansetInfo = ({ setSelectedSIMType, equipmentSimTypes, cmsData }) => {
  const theme = useTheme();
  const graphql = useApolloClient();
  const [selectedTypeApiValue, setSelectedTypeApiValue] = useState(null);
  const [simTypes, setSimTypes] = useState([]);

  useEffect(() => {
    const loadSimTypes = async () => {
      const apiType = await fetchSimTypes(graphql);
      setSimTypes(apiType);
      //  default to ESIM if handset is ESIM only
      if (equipmentSimTypes === 'ESIM' && apiType.includes('ESIM')) {
        const internalValue = mapApiToInternalSimType.ESIM;
        const apiValue = mapInternalToApiSimType[internalValue];
        setSelectedTypeApiValue(apiValue);
        setSelectedSIMType(apiValue);
      }
    };
    loadSimTypes();
  }, []);
  const handleSelect = async type => {
    const apiValue = mapInternalToApiSimType[type];
    setSelectedTypeApiValue(apiValue);
    setSelectedSIMType(apiValue);
  };

  return (
    <Box sx={styles(theme).handsetContainer}>
      <Grid container justifyContent='center' alignItems='stretch'>
        {simTypes.includes('ESIM') && (
          <Grid item xs={12}>
            <Box sx={{ height: '100%' }}>
              <Paper
                variant='outlined'
                sx={{
                  height: '100%',
                  ...styles(theme).option,
                  ...(selectedTypeApiValue === 'ESIM' ? styles(theme).selected : null),
                }}
                onClick={() => handleSelect(mapApiToInternalSimType.ESIM)}
              >
                <Box sx={styles(theme).optionContent}>
                  <Box sx={styles(theme).buttonIcon}>
                    {selectedTypeApiValue === 'ESIM' ? (
                      <img
                        src={
                          getCookie('cart_Type') === 'CHANGE_OFFER'
                            ? `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsData?.data?.attributes?.CO_ESIMOnly?.selectedIcon?.data?.attributes?.url}`
                            : `${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsData?.data?.attributes?.ACQ_CS_ESIMOnly?.selectedIcon?.data?.attributes?.url}`
                        }
                        alt=''
                        style={styles(theme).inlineIcon}
                      />
                    ) : (
                      ''
                    )}
                  </Box>
                  <Box sx={styles(theme).textContainer}>
                    <Typography
                      variant='subtitle2'
                      sx={{
                        ...styles(theme).buttonTitle,
                        ...(selectedTypeApiValue === 'ESIM' ? styles(theme).selectedText : null),
                      }}
                    >
                      {getCookie('cart_Type') === 'CHANGE_OFFER'
                        ? cmsData?.data?.attributes?.CO_ESIMOnly?.title
                        : cmsData?.data?.attributes?.ACQ_CS_ESIMOnly?.title}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{
                        ...styles(theme).buttonDescription,
                        ...(selectedTypeApiValue === 'ESIM' ? styles(theme).selectedText : null),
                      }}
                    >
                      {getCookie('cart_Type') === 'CHANGE_OFFER'
                        ? cmsData?.data?.attributes?.CO_ESIMOnly?.description
                        : cmsData?.data?.attributes?.ACQ_CS_ESIMOnly?.description}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default ESIMOnlyHansetInfo;
